<template>
  <van-popup :value="value" position="center" class="receive-result-popup" @click-overlay="close">
    <div class="popup-body" v-if="value">
      <img class="icon" :src="type === 'success'
          ? 'https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-n-member-receive-success'
          : 'https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-n-member-receive-fail'
        " alt="" />
      <span class="title">{{
        type === 'success' ? '领取成功！' : '领取失败！'
      }}</span>
      <span class="desc">{{ message }}</span>
      <div class="btn" @click="onBtnClick">
        {{ type === 'success' ? '下载app开始运动' : '关闭' }}
      </div>
      <img class="pop-logo" v-if="type === 'success'"
        src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-btm-logo" alt="">
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // success | fail
    type: {
      type: String,
      default: 'success'
    },
    // 弹窗说明文案
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    onBtnClick() {
      if (this.type === 'success') {
        this.$emit('download')
      } else {
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.receive-result-popup {
  border-radius: 12px;
}

.popup-body {
  width: 305px;
  background: rgba(245, 245, 245, 1);
  border-radius: 12px;
  padding: 30px 25px 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    width: 70px;
    height: 70px;
  }

  .title {
    margin-top: 20px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(5, 11, 39, 1);
    text-align: center;
    line-height: 28px;
  }

  .desc {
    margin-top: 14px;
    width: 230px;
    font-size: 15px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(5, 11, 39, 1);
    text-align: center;
    line-height: 24px;
  }

  .btn {
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background: rgba(5, 11, 39, 1);
    border-radius: 24px;
    padding: 11px 0 12px;
    box-sizing: border-box;
    margin-top: 35px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 25px;

    &:active {
      opacity: 0.6;
    }
  }
  .pop-logo {
    width: 147px;
    height: 14px;
    filter: brightness(0) invert(60%);
    margin-top: 20px;
  }
}
</style>
